<h2 mat-dialog-title style="text-align: center; font-size: x-large;">{{'D_T5' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <div *ngIf="step === 0">
        <p style="font-size: large;">
            {{'D_P10' | translate}}
        </p>
        <div style="display: flex; justify-content:space-between; padding-top: 1rem;">
            <button mat-raised-button class="button" (click)="block()">{{'MEM_YES' | translate}}</button>
            <button mat-raised-button mat-dialog-close class="button">{{'MEM_NO' | translate}}</button>
        </div>
    </div>
    <div *ngIf="step === 1">
        <p style="font-size: large;">
            {{'D_P9' | translate}}
        </p>
    </div>
</mat-dialog-content>
